import Page from '../UiControllers/Terms/privacyPolicy'

new Page({})
